import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import React, { useEffect } from 'react';
import Form from '../Form';
import FormInput from '../FormInput';
import FormSelect from '../FormSelect';

const BlockSearch = ({ onQuery, onRarityFilter }) => {
  const formSchema = yup.object().shape({
    rarityFilter: yup.string(),
    query: yup.string(),
  });

  const form = useForm({
    defaultValues: {
      rarityFilter: '',
      query: '',
    },
    resolver: yupResolver(formSchema),
  });

  const query = form.watch('query');
  const rarityFilter = form.watch('rarityFilter');

  useEffect(() => {
    onRarityFilter(rarityFilter);
  }, [rarityFilter]);

  useEffect(() => {
    onQuery(query);
  }, [query]);

  return (
    <div className='md:flex md:justify-end'>
      <Form form={form} className='flex flex-col md:flex-row gap-4'>
        <FormInput name='query' placeholder='Search blocks' />
        <FormSelect
          name='rarityFilter'
          placeholder='Filter by rarity'
          options={[
            { value: '', label: 'All' },
            { value: 'Collab', label: 'Collab' },
            { value: 'Common', label: 'Common' },
            { value: 'Uncommon', label: 'Uncommon' },
            { value: 'Rare', label: 'Rare' },
            { value: 'Ultra Rare', label: 'Ultra Rare' },
            { value: 'Legendary', label: 'Legendary' },
          ]}
        />
      </Form>
    </div>
  );
};

export default BlockSearch;
